import { renderCellByType } from "../FlotteTable/Cells/Cells";

export const getValueFromPath = (obj, path) => {
  if (!path || !obj) return null;

  return path.split(".").reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : null;
  }, obj);
};

// Formater une valeur selon son type en utilisant renderCellByType
export const formatValue = (value, type, columnKey, item) => {
  // Gestion spéciale pour l'immatriculation avec font-weight-bold
  if (columnKey === "immatriculation") {
    const formatted = renderCellByType("immatriculation", value, item);
    return formatted;
  }

  // Utiliser renderCellByType pour tous les autres cas
  const formatted = renderCellByType(type, value, item);

  // Si renderCellByType ne retourne rien ou une chaîne vide, afficher "---"
  if (formatted === null || formatted === undefined || formatted === "") {
    return "---";
  }

  return formatted;
};

// Obtenir l'icône selon la catégorie
export const getCategoryIcon = (category) => {
  const iconMap = {
    Identification: "fa-id-card",
    Contrat: "fa-file-contract",
    Financier: "fa-euro-sign",
    Commande: "fa-shopping-cart",
    Retour: "fa-undo",
    Vente: "fa-handshake",
  };
  return iconMap[category] || "fa-folder";
};
